import { css, Global } from "@emotion/react";
import theme from "@theme";

const inputStyles = css`
  .MuiTabs-root .MuiTab-root.Mui-selected {
    color: white !important;
    font-weight: 600 !important;
  }

  .MuiTabs-indicator {
    display: none !important;
  }

  .MuiTab-root {
    text-transform: none !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    color: #6b7280 !important;
    padding: 12px 24px !important;
    border-radius: 12px !important;
    margin: 0 4px !important;
    transition: all 0.3s ease !important;
    min-height: 48px !important;
    
    &:hover {
      background: rgba(227, 110, 0, 0.05) !important;
      color: #E36E00 !important;
    }

    &.Mui-selected {
      background: linear-gradient(135deg, #E36E00 0%, #FFAE00 100%) !important;
      color: white !important;
      -webkit-text-fill-color: white !important;
      animation: slideIn 0.3s ease !important;
    }
  }

  @keyframes slideIn {
    from {
      transform: translateX(-20px) !important;
      opacity: 0.8 !important;
    }
    to {
      transform: translateX(0) !important;
      opacity: 1 !important;
    }
  }

  .MuiTabs-root {
    background: rgba(255, 255, 255, 0.8) !important;
    backdrop-filter: blur(10px) !important;
    border-radius: 16px !important;
    padding: 8px !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
  }
`;

const GlobalStyles = () => <Global styles={inputStyles} />;

const SC = {
  GlobalStyles,
};

export default SC;
